import { useAtom, useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import {
  getSafeFormEditorReturnPath,
  shouldSelectFormsTabAfterLeavingFormEditor,
} from '@/utils/form-editor-return-path';
import { TemplateCategory } from '@heidi/schema/ml-scribe';
import {
  formEditorReturnPathAtom,
  templateCategoryFilterAtom,
  templateTablePageAtom,
} from '@heidi/templates/data';

export function useNavigateAwayFromFormEditor() {
  const router = useRouter();
  const [formEditorReturnPath, setFormEditorReturnPath] = useAtom(
    formEditorReturnPathAtom
  );
  const setTemplateCategoryFilter = useSetAtom(templateCategoryFilterAtom);
  const setTemplateTablePage = useSetAtom(templateTablePageAtom);

  return useCallback(
    (method: 'push' | 'replace') => {
      const target = getSafeFormEditorReturnPath(formEditorReturnPath);
      setFormEditorReturnPath(null);
      if (shouldSelectFormsTabAfterLeavingFormEditor(target)) {
        setTemplateCategoryFilter(TemplateCategory.FORM_TEMPLATE);
        setTemplateTablePage(1);
      }
      void router[method](target);
    },
    [
      formEditorReturnPath,
      router,
      setFormEditorReturnPath,
      setTemplateCategoryFilter,
      setTemplateTablePage,
    ]
  );
}
